import Usercentrics, { DefaultUISettings, Service, TCFUISettings, UI_VARIANT } from '@usercentrics/cmp-browser-sdk';
import { useEffect, useState } from 'preact/hooks';
import { EMBEDDING_CONTAINER_CLASS_NAME } from '../embeddings/constants';
import { EmbedSettingNames } from '../embeddings/tcfEssentials';
import { getCurrentUiCategoriesChoices } from '../App.helpers';
import { useCategoryContext } from '../contexts/CategoryContext';
import { useSettingsContext } from '../contexts/SettingsContext';
import { useUiContext } from '../contexts/UiContext';

/**
 * EMBEDDINGS
 * If embeddings are enabled, the host website will be searched for any html elements with the 'uc-embed' class name,
 * Information on the specified services will then be rendered inside these containers.
 */
export const useEmbeddings = (UC: Usercentrics): void => {
  const [initialized, setInitialized] = useState(false);
  const { categories } = useCategoryContext();
  const { setCategories } = useCategoryContext();
  const { settings } = useSettingsContext();
  const { uiVariant } = useUiContext();
  const tcfData = UC.getTCFData();

  const services = categories.reduce((acc: Service[], cur) => {
    if (!cur.services) {
      return acc;
    }

    return [...acc, ...cur.services];
  }, []);

  const tcfContainers = Array.from(document.getElementsByClassName(EmbedSettingNames.embedTCFAnkerName));
  const serviceContainers = Array.from(document.getElementsByClassName(EMBEDDING_CONTAINER_CLASS_NAME));

  useEffect(() => {
    if (
      (serviceContainers.length > 0 || tcfContainers.length > 0) &&
      Array.isArray(categories) &&
      categories.length > 0 &&
      !initialized
    ) {
      setInitialized(true);
      UC.loadServices().then(() => {
        setCategories(getCurrentUiCategoriesChoices(UC.getCategories(), categories));
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categories, initialized]);

  useEffect(() => {
    if (settings?.ui?.isEmbeddingsEnabled && uiVariant != null) {
      setInitialized(true);

      if (tcfContainers.length > 0 && settings.isTcfEnabled && tcfData) {
        import('../embeddings/tcf').then((embedTCF) => {
          embedTCF.embedTCF(tcfData, services, categories, settings.ui as TCFUISettings, tcfContainers);
        });
      }

      if (serviceContainers.length > 0 && Array.isArray(categories) && categories.length > 0) {
        const labels =
          uiVariant === UI_VARIANT.TCF
            ? (settings.ui as TCFUISettings).labels.nonTCFLabels
            : (settings.ui as DefaultUISettings).labels;
        // TODO: Check if there is anything we need to do for CCPA here. Passing the labels correctly probably (from CCPAUISettings)
        import('../embeddings/services').then((embedServices) => {
          embedServices.embedServices(services, labels, serviceContainers);
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uiVariant, categories, services, settings]);
};
